import { Button } from '$components'
import { useEditPricingForm } from '.'

export function EditPricingControls() {
  const { onCancel, isLoading } = useEditPricingForm()

  return (
    <div className="flex gap-4 mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Button
        isLoading={isLoading}
        type="submit"
        size="lg"
      >
        Save pricing
      </Button>
    </div>
  )
}
